module.exports = __webpack_public_path__ + "img/cathedis-logo.9bd16aed.png";